var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    stroke: "#3CB4E5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.6438,
    y1: 5.42387,
    x2: 5.35364,
    y2: 12.7141,
    stroke: "#3CB4E5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5173,
    y1: 12.7207,
    x2: 5.2271,
    y2: 5.43055,
    stroke: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircleCross);
export default __webpack_public_path__ + "static/media/blueCircleCross.b879f7ff8f92c6aa177a672bdb00b9d8.svg";
export { ForwardRef as ReactComponent };